import { useRef } from "react";
import { AutoRolloverContent } from "../PreferencesComponents/SystemPreferencesComponents/AutoRolloverContent";
import { toast } from "react-toastify";
import { useUpdateTaskType } from "../../data/mutations/taskTypeMutations";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const PreferencesContainer = ({ taskType }) => {
  const { t } = useTranslation(["TaskTypes", "Preferences"]);

  const autoRolloverRef = useRef(null);

  const { mutate: updateTaskType } = useUpdateTaskType();
  const queryClient = useQueryClient();

  const onTaskTypeModified = () => {
    let modifiedTaskType = {
      ...taskType,
    };

    modifiedTaskType = {
      ...modifiedTaskType,
      AutoRollover: autoRolloverRef.current?.getValue(),
    };

    updateTaskType(
      { taskType: modifiedTaskType },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["get-task-type", taskType?.Id]);
          toast.success(t("TaskTypeUpdated"), {
            position: "bottom-left",
          });
        },
        onError: (res) => {
          if (res?.data.errors?.Title)
            toast.error(res?.data.errors?.Title[0], {
              position: "bottom-left",
            });
          else if (res?.data.errors?.Key)
            toast.error(res?.data.errors?.Key[0], {
              position: "bottom-left",
            });
          else toast.error(t("ErrorMsg"), { position: "bottom-left" });
        },
      }
    );
  };

  return (
    <div>
      <div className="mb-3 mt-2">
        <div className="et-darkest-gray fs-14">
          {t("Preferences:Title", { taskType: taskType?.Title })}
        </div>
      </div>
      <AutoRolloverContent
        ref={autoRolloverRef}
        autoRolloverData={taskType}
        message={t("Preferences:SystemPreferences.AutoRolloverMessage")}
        showTooltip={false}
        onChange={onTaskTypeModified}
        show={true}
      />
    </div>
  );
};
